(function () {
	const _areas = document.querySelectorAll('.js-park-area');
	
	if (!_areas) {
		return;
	}
	
	let direction;
	let index = 0;
	let lastIndex = 0;
	const maxIndex = _areas.length - 1;
	
	function init() {
		document.addEventListener('click', click);
	}
	
	function click(event) {
		if (util.hasClass(event.target, 'js-park-area-prev-button')) {
			direction = -1;
		} else if (util.hasClass(event.target, 'js-park-area-next-button')) {
			direction = 1;
		} else {
			return;
		}
		
		index += direction;
		
		if (index < 0) {
			index = maxIndex;
		} else if (index > maxIndex) {
			index = 0;
		}
		
		util.removeClass(_areas[lastIndex], 'is-visible');
		_areas[lastIndex].setAttribute('aria-hidden', 'true');
		
		util.addClass(_areas[index], 'is-visible');
		_areas[index].setAttribute('aria-hidden', 'false');
		
		_areas[index].querySelector('.js-park-area-' + (direction === -1 ? 'prev' : 'next') + '-button').focus();
		
		lastIndex = index;
	}
	
	init();
}());